// Reusable Wompi payment starter.
// Given a pending payment (`payment_id` or `checkout_id`), calls
// `/payments/wompi/init` and redirects to Wompi Web Checkout.
import { api } from './api';
import { paymentReturnOrigin, openWompiCheckout } from './native';

export async function startWompiPayment({ payment_id, checkout_id, customer_email, customer_name, customer_phone }) {
  const { data: init } = await api.post('/payments/wompi/init',
    payment_id ? { payment_id, customer_email } : { checkout_id, customer_email }
  );
  const redirectUrl = `${paymentReturnOrigin()}${init.redirect_url_path}?ref=${encodeURIComponent(init.reference)}`;
  const params = new URLSearchParams({
    'public-key': init.public_key,
    'currency': init.currency,
    'amount-in-cents': String(init.amount_in_cents),
    'reference': init.reference,
    'signature:integrity': init.integrity_signature,
    'redirect-url': redirectUrl,
    'customer-data:email': init.customer_email || customer_email || '',
    'customer-data:full-name': customer_name || '',
    'customer-data:phone-number': customer_phone || '',
  });
  await openWompiCheckout(`${init.checkout_url}?${params.toString()}`, init.reference);
}

// Fetch the /api/config/payments once and cache it in a promise. Callers
// can await it in any component to decide between simulated and wompi.
let _cfgPromise = null;
export function getPaymentsConfig() {
  if (!_cfgPromise) {
    _cfgPromise = api.get('/config/payments').then((r) => r.data).catch(() => ({
      mode: 'simulated', wompi: { enabled: false },
    }));
  }
  return _cfgPromise;
}
